import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col } from 'reactstrap';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import Message from '../../Common/components/Message';
import messageStore from '../../Common/stores/messageStore';
import withNavigate from '../../Common/components/withNavigate';  

@observer
class ConfirmationScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false
    };
  }

  componentWillMount () {
    if (housingstore.getSupportiveHousingRouteStatus('/reviewsubmit') !== 'completed') {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirect: true })
    }
  }

  componentDidMount() {
    if(!housingstore.confirmationId) {
      housingstore.clearHousingAssessmentForm();
      this.setState({
        redirect: true
      });
    }
    this.setMessage();
  }

  setMessage = () => {
    messageStore.setMessages("Technical error please try again later", "danger");
    messageStore.populateMessages();
    return (
      <Message messageStore={messageStore} />
    );
  }


  render() {
    const { submitSuccess, confirmationId } = housingstore;

    if(this.state.redirect) {
      housingstore.clearHousingAssessmentForm();
      housingstore.resetSupportiveHousingPage();
      return <Navigate to="/" />
    }

    return(
      <div className="border-form">
        { submitSuccess ?
          <>
            <Row className="custom-box">
              <Col>
                <div className="center-text">
                  <i className="icon icon-ok-circle check-icon" />
                </div>
                <div className="spacer" />
                <div className="center-text poppinsH5-Confirmation">
                  Confirmation: <b>{confirmationId}</b>
                </div>
                <div className="spacer" />
                <h5 className="center-text confirmationTitle poppinsH5-ThankYouNote">
                  {`The FCS assessment has been successfully submitted. We are currently processing
                  your request and will notify you within  five business days with the status of the assessment.`}
                </h5>
                <div className="spacer" />
                <h5 className="center-text poppinsH5-ThankYouNote">
                  If you have questions about the status of an individual or have not heard 
                  back from us after the 6th business day, please email 
                  (<a style={{ textDecoration: 'underline' }} href={`mailto:FCSTPA@Wellpoint.com`}>FCSTPA@Wellpoint.com</a>) 
                  or call us (1-844-451-2828).
                </h5>
                <div className="spacer" />
              </Col>
            </Row>
          </>
          :
          <Message messageStore={messageStore} />
        }
      </div>
    );
  }
}

export default withNavigate(ConfirmationScreen);

ConfirmationScreen.propTypes = {
  navigate: PropTypes.func
};